import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Userloginattempt from '../entities/userloginattempt'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
interface UserloginattemptState extends ListState<Userloginattempt>{
}
class UserloginattemptModule extends ListModule<UserloginattemptState,any,Userloginattempt>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Userloginattempt>(),
        loading:false
    }
    actions={
        async getPaged(context:ActionContext<UserloginattemptState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Userloginattempt/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Userloginattempt>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        }

    };
    mutations={
        setCurrentPage(state:UserloginattemptState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:UserloginattemptState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const userloginattemptModule=new UserloginattemptModule();
export default userloginattemptModule;